import { useEffect } from 'react';
import { useReactFlow } from '@xyflow/react';

export const AutoFitGraph = () => {
  const { fitView } = useReactFlow();
  useEffect(() => {
    fitView();
  }, [fitView]);

  return null;
};
